import { http, utils } from "~/utils";
import * as moment from "moment";
export default {
    getAll: async (page = 1, filters = {}, format_result = false) => {
        return await new Promise((resolve, reject) => {
            const date_filters = ["date_gte", "date_lte", "creation_date_gte", "creation_date_lte"];
            let request_filters = { ...filters };
            Object.keys(request_filters).forEach(element => {
                if (date_filters.indexOf(element) !== -1) {
                    if (request_filters[element]) {
                        request_filters[element] = moment(filters[element]).format("DD/MM/YYYY");
                    }
                }
            });
            http.get("/cpo/", {
                params: {
                    page: page,
                    ...request_filters,
                    format_result
                }
            })
                .then(response => {
                    let list = response.data.results.map(order => ({
                        ...order,
                        ...order.extra_fields
                    }));
                    let process_pagination = {
                        actual: response.data.actual,
                        count: response.data.count,
                        next: response.data.next,
                        pages: response.data.pages,
                        previous: response.data.previous
                    }
                    resolve({
                        list: list,
                        pagination: process_pagination,
                        fields: response.data.form_filter
                    });
                })
                .catch(error => reject(error));
        });
    },
    getItems: async cpoID => {
        return http.get(`/cpo/cpo-list/${cpoID}/`).then(response => response.data.cpo);
    },
    getHistory: async cpoID => {
        return http.get(`/cpo/cpo-list/${cpoID}/history/`).then(response => response.data.cpos);
    },
    sendReport: async reportData => {
        return http.post("/cpo/cpo-report/", { query_kwargs: reportData })
            .then(response => {
                return response
            })
            .catch(error => {
                return error
            })
    },
    getCMNReport: async filters => {
        return http.post(`/india/register/cmn-report/`, filters, {responseType: "blob"}).then(response => {
            const filename = "CMN_REPORT.xlsx";
            if (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
            }
        });
    },
    getCostPackageBySSOTReport: async filters => {
        return http.post(`/india/site_service_order_template_item/cost-package-by-ssot-report/`, filters).then(response => {
            return response
        });
    },
    getPRValidationReport: async filters => {
        return http
            .post(`/india/pr-validation/pr-validation-report/`, filters, {responseType: "blob"})
            .then(response => {
                const filename = "PR Validation & Run ID Closure Report.zip";
                if (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", filename);
                    document.body.appendChild(link);
                    link.click();
                }
            });
    },
    getCpoItem: async (cpoID, itemID) => {
        return http.get(`/cpo/cpo-list/${cpoID}/items/${itemID}/`).then(response => response.data.cpo_item);
    },
    cancelCpoItem: async (cpoID, itemID) => {
        return http.post(`/cpo/cpo-list/${cpoID}/items/${itemID}/cancel/`).then(response => response.data);
    },
    getCpoItemComments: async (cpoID, itemID) => {
        return http
            .get(`/cpo/cpo-list/${cpoID}/items/${itemID}/comments/`)
            .then(response => response.data.comments);
    },
    newCommet: async (cpoID, itemID, username, message) => {
        return http
            .post(`/cpo/cpo-list/${cpoID}/items/${itemID}/comments/`, {
                username,
                message
            })
            .then(response => response.data.comment);
    },
    download: async cpoID => {
        return http
            .get(`/cpo/cpo-list/${cpoID}/download/`, {
                responseType: "blob"
            })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "file.pdf");
                document.body.appendChild(link);
                link.click();
            });
    },
    reParseCpoFile: async parse_file_ids => {
        return http.post(`/cpo/re-parse-cpo-file/`, { parse_file_ids });
    },
    cancelCpo: async (cpoID, cpo_number) => {
        return http
            .put(`/india/register/${cpoID}/`, {
                status: "cancelled",
                is_history_log: false,
                cpo_id: cpoID,
                cpo_number
            })
            .then(response => response.data.cpo);
    },
    nonOetRelatedCpo: async (cpoID, cpo_number) => {
        return http
            .put(`/india/register/${cpoID}/`, {
                status: "non_oet_related",
                cpo_id: cpoID,
                cpo_number
            })
            .then(response => response.data);
    },
    unCancelCpo: async cpoID => {
        return http.put(`/cpo/cpo-list/${cpoID}/cancel/`).then(response => response.data.cpo);
    },
    uploadCPOFile: async (file, customer_team) => {
        const formData = new FormData();
        formData.append("uploaded_file", file);
        formData.append("customer_team", customer_team);
        return http
            .post(`/cpo/cpo-upload/`, formData, {
                headers: { "content-type": "multipart/form-data" }
            })
            .then(response => response && response.data);
    },
    updateCPO: async (cpo_id, circle, project, effective_to_date, blank_oet_received_date) => {
        return http
            .patch(`/india/register/${cpo_id}/`, {
                ...(circle ? { circle } : {}),
                ...(project ? { project } : {}),
                ...(blank_oet_received_date ? { blank_oet_received_date } : {}),
                ...(effective_to_date ? { effective_to_date } : {})

            })
            .then(response => response.data);
    },
    getCpoUpload: async () => {
        return http.get("/cpo/cpo-upload/").then(response => response.data);
    },
    listCircles: async (search = null) => {
        let ops = {};
        if (search) {
            ops = {
                params: {
                    search
                }
            };
        }
        return http.get("/india/circle/", ops).then(response => response.data);
    },
    createItem_foc: async (
        cpo_id,
        {
            item,
            code,
            description,
            quantity,
            value_on_cpo,
            gross_value,
            delivery_date,
            type,
            quantity_spent_external,
            quantity_contract_number
        }
    ) => {
        return http
            .post(`/cpo/cpo-list/${cpo_id}/item-foc/`, {
                item,
                code,
                description,
                quantity,
                value_on_cpo,
                gross_value,
                type,
                extra_fields: {
                    delivery_date,
                    quantity_spent_external,
                    quantity_contract_number
                }
            })
            .then(response => response);
    },
    updateItem_foc: async (cpo_id, item_id, data) => {
        return await http
            .patch(`/cpo/cpo-list/${cpo_id}/item-foc/${item_id}/`, {
                type: data.type,
                extra_fields: {
                    quantity_spent_external: data.quantity_spent_external,
                    quantity_contract_number: data.quantity_contract_number
                }
            })
            .then(response => response);
    },
    sendNotificationPending: async cpo_regiter_id => {
        return http
            .post(`/india/register/${cpo_regiter_id}/send-notification-pending/`)
            .then(response => response.data);
    },
    reOpenCPO: async cpo_regiter_id => {
        return http.post(`/india/register/${cpo_regiter_id}/re-open-cpo/`).then(response => response.data);
    },
    updateTcc: async (
        oet_id,
        {
            for_offer_number_created_in_csp,
            quantity_contract_number,
            sap_top_wbs,
            customer_payment_terms,
            incoterms,
            incoterms_code,
            payment_terms_code,
            sales_order_billing_plan,
            sap_customer_name,
            sap_down_payment_contract_number
        }
    ) => {
        return await http
            .put(`/india/oet/${oet_id}/update-tcc/`, {
                sap_top_wbs,
                for_offer_number_created_in_csp,
                quantity_contract_number,
                customer_payment_terms,
                incoterms,
                incoterms_code,
                payment_terms_code,
                sales_order_billing_plan,
                sap_customer_name,
                sap_down_payment_contract_number
            })
            .then(response => response.data);
    },

    startTemporaryOet: async oet_id => {
        return http.post(`/india/oet/${oet_id}/start-temporary-oet/`)
            .then(response => response.data);
    },
    switch_bulk_and_sode_state: async cpo_regiter_id => {
        return http.post(`india/register/${cpo_regiter_id}/switch-bulk-and-sode-state/`)
            .then(response => response.data);
    },
    sendFile:(data, offline_id=null)=>{
        if(!offline_id){
            return http.post(`/india/offline-approval/`, data, {
                headers: { "content-type": "multipart/form-data" }
            })
            .then(response => response.data)
        }else{

            return http.put(`/india/offline-approval/${offline_id}/`, data, {
                headers: { "content-type": "multipart/form-data" }
            })
            .then(response => response.data)
        }


    },
    approveOfflineApproval: (run_id) => {
        return http.post(`/india/offline-approval/approve-offline/${run_id}/`)
        .then(response=> response.data)
    },


    downloadOfflineApproval: async (content_type, file_name, run_id) => {
        const _file_name = file_name.split(".")[0]
        const file_extension = file_name.split(".")[1]
        const service = http
            .get(`/india/offline-approval/export-offline-approval/${content_type}/${run_id}/`, {
                responseType: "blob"
            })
        return utils.download(
            service, _file_name, file_extension
        )
    },
};
